export default "/images/ai__page_heading.png";